const PATTERNS = Object.freeze({
  MARKSPATTERN: /^['"]+|['"]+$/gi,
  CONDOPATTERN: /\bcond(\.+|om\S*|ômin\S*|ómin\S*|ômín\S*|o\b|\b)|\bcndo*\b/gi,
  EDPATTERN: /^ed[.fd]*$|^s(n|\.n|\/n)$|^n(\.a|a|\/a)$|^x+$|^0*$|^e\b/gi,
  PREPOSITIONSPATTERN: /^dos\b|^das\b|^do\b|^da\b/gi,
  INVALIDTERMS: /.*\bsem\b.*|.*\bnão\b.*|.*\bnao\b.*|^nome do\b.*/gi, // erases the whole string
  PUNCTUATIONPATTERNS: /^[.!?\-_;*]+|[.!?\-_;*]+$/gi,
});

export const cleanUpCondoName = (name) => {
  let newName = name;

  if (typeof name === 'string') {
    newName = newName.replace(PATTERNS.MARKSPATTERN, '').trim();
    newName = newName.replace(PATTERNS.CONDOPATTERN, '').trim();
    newName = newName.replace(PATTERNS.EDPATTERN, '').trim();
    newName = newName.replace(PATTERNS.PREPOSITIONSPATTERN, '').trim();
    newName = newName.replace(PATTERNS.INVALIDTERMS, '').trim();
    newName = newName.replace(PATTERNS.PUNCTUATIONPATTERNS, '').trim();

    if (!name) {
      return null;
    }
    return newName;
  }
  return null;
};
